<template>
  <SeoFooterLinksContainer
    :sections="[
      seoSectionsApple,
      seoSectionsSmartphone,
      seoSectionsTablet,
      seoSectionsMacbook,
      seoSectionsGamingConsole,
      seoSectionsAudio,
    ]"
    @link-click="handleLinkClick"
  />
</template>

<script setup lang="ts">
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import { useSeoProductsByCategory } from '../../composables/useSeoProductsByCategory'
import SeoFooterLinksContainer from '../SeoFooterLinks/SeoFooterLinksContainer.vue'

const { trackClick } = useTracking()

const [
  { seoSections: seoSectionsApple },
  { seoSections: seoSectionsSmartphone },
  { seoSections: seoSectionsTablet },
  { seoSections: seoSectionsMacbook },
  { seoSections: seoSectionsGamingConsole },
  { seoSections: seoSectionsAudio },
] = await Promise.all([
  useSeoProductsByCategory('smartphone', 'Apple'),
  useSeoProductsByCategory('smartphone'),
  useSeoProductsByCategory('tablet'),
  useSeoProductsByCategory('macbook'),
  useSeoProductsByCategory('gaming_console'),
  useSeoProductsByCategory('audio'),
])

function handleLinkClick(productClicked: { label: string; position: number }) {
  trackClick({
    zone: 'buyback_home',
    name: 'footer_link_click',
    value: {
      productName: productClicked.label,
      position: productClicked.position,
    },
  })
}
</script>
